// src/components/CustomComponents/ModalForm.jsx
import React from 'react'
import { Stack } from '@mui/material'
import CustomModalClose from 'src/components/CustomComponents/CustomModalClose'
import CustomButton from 'src/components/CustomComponents/CustomButton'

function ModalForm({ open, handleClose, handleSubmit, children }) {
	return (
		<CustomModalClose
			open={open}
			onClose={handleClose}
			aria-labelledby="modal-form-title"
			aria-describedby="modal-form-description"
		>
			<form
				onSubmit={(e) => {
					e.preventDefault()
					handleSubmit?.()
				}}
			>
				<Stack alignItems="center" spacing={4} sx={{ margin: '20px 0' }}>
					{/* Form content */}
					{children}

					<Stack direction="row" spacing={5}>
						<CustomButton
							variant="outlined"
							sx={{
								width: 100,
								background: 'red',
								color: 'white',
								border: '1px solid red',
								':hover': {
									color: 'red',
									border: '1px solid red',
								},
							}}
							onClick={handleClose}
						>
							Cancel
						</CustomButton>
						<CustomButton
							type="submit"
							variant="outlined"
							sx={{
								width: 100,
								background: '#124984',
								color: 'white',
								':hover': {
									color: '#124984',
								},
							}}
						>
							Submit
						</CustomButton>
					</Stack>
				</Stack>
			</form>
		</CustomModalClose>
	)
}

export default React.memo(ModalForm)
